import React from 'react';

import { ArticleHeroCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './ArticleHero.styles';

export interface ArticleHeroProps {
  data: ArticleHeroCMS;
}

const defaultProps: Partial<ArticleHeroProps> = {};

const ArticleHero: React.FunctionComponent<ArticleHeroProps> = ({
  data,
  ...rest
}) => {
  return (
    <S.ArticleHeroWrapper>
      <S.Hero src={data.image.url} {...rest} />
      <S.WordsByWrapper>
        {data.articleAuthor && (
          <S.DataRow>
            <S.Label>Words by </S.Label>
            <S.Data>{data.articleAuthor}</S.Data>
          </S.DataRow>
        )}
        {data.date && (
          <S.DataRow>
            <S.Label>Date </S.Label>
            <S.Data>{data.date}</S.Data>
          </S.DataRow>
        )}
      </S.WordsByWrapper>
    </S.ArticleHeroWrapper>
  );
};

ArticleHero.defaultProps = defaultProps;

export default ArticleHero;
